import React, { useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs';
import { ApplicationTitle, GroupListTitle, ReviewTemplateListTitle } from '../../../Utils/Constants';
import GroupListNav from './GroupListNav';
import GroupListTabContent from './GroupListTabContent';
import Authorized from '../../../CommonElements/Authorisation/Authorise';

export default function GroupListContainer() {
    const [activeTab, setActiveTab] = useState(1);

    // Fetch userId and role from localStorage or context
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const userId = user?.id || '';
    const role = user?.role || '';

    return (
        <>
            <Breadcrumbs pageTitle={GroupListTitle} parent={ApplicationTitle} title={GroupListTitle} />
            <Container fluid>
                <Row className="project-cards">
                    <Authorized allowed={["admin", "group leader"]}>

                        <Col md={12} className="project-list">
                            <GroupListNav activeTab={activeTab} setActiveTab={setActiveTab} />
                        </Col>
                    </Authorized>
                    <Col sm={12}>
                        <GroupListTabContent activeTab={activeTab} userId={userId} role={role} />
                    </Col>
                </Row>
            </Container>
        </>
    );
}